<template>
  <div class="device-detail-resume-bd">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent label-position="left">
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 日期过滤 -->
        <el-form-item style="float: right">
          <!-- 部件编码  -->
          <search-input v-model="formSearch.search" :placeholder="$t('dms_device_detail_resume.zjmcljmc')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
      :data="tableList"
      :column="tableColumn"
      @filter="filterChange"
      @sort="sortChange"
      max-height="600"
      :slots="['currentVal', 'remainVal', 'remainPercent']"
    >

        <template v-slot:currentVal="scope">
          <span type="text" :style="{ color:  scope.row.currentVal >= scope.row.criticalVal? 'red-text' : 'green-text' }">{{ scope.row.currentVal||0 }}</span>

        </template>
        <template v-slot:remainVal="scope">
          <span type="text" :style="{ color: scope.row.currentVal >= scope.row.criticalVal ? 'red-text' : 'green-text' }">{{scope.row.remainVal}}</span>
        </template>
        <template v-slot:remainPercent="scope">
          <span type="text" :class="scope.row.currentVal >= scope.row.criticalVal ? 'red-text' : 'green-text'" >{{ (scope.row.remainPercent * 100).toFixed(0) + '%' }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    deviceInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: { },
  data() {
    return {
      tableCode: 'device_detail_resume',
      provide: true,
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        bodyNum: '',
        search: '',
        pubTimer: [],
        pubStartDate: '',
        pubEndDate: '',
        uploadTimer: [],
        uploadStartDate: '',
        uploadEndDate: ''
      },
      exportTimer: '',
      tableList: [],
      totalRows: 0,
    };
  },
  mounted: function () {
    this.formSearch.bodyNum = this.deviceInfo.bodyNum;
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.formSearch.bodyNum = this.deviceInfo.bodyNum;
      this.$getJSON(apis.DeviceResumeComponentPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });

    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.DeviceResumeComponentExport, this.formSearch).then(() => { });
    },
  },
};
</script>

<style lang="scss">
.device-detail-resume-bd {
  padding: 8px 24px 44px 24px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  .green-text {
    color: green;
  }
  .red-text {
    color: red;
  }

}
</style>
